import { AbstractControl } from "@angular/forms";

export const strongPassword = (control: AbstractControl) => {
  const value = control.value as string;
  if (!value) return null;

  if (value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/)) return null;
  return { strongPassword: true };
};
